// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1731":"05d91ba5","6198":"05d91ba5","9322":"4633a33f"}[chunkId] + ".chunk.css";
};